import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from '../service/auth.service';
import { RolePermissionEnum } from '../service/dto';

@Directive({
	selector: '[hasPermission]',
	standalone: false
})
export class HasPermissionDirective {
	private state = false;

	constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private authService: AuthService) { }

	@Input()
	set hasPermission(requiredPermissions: RolePermissionEnum[]) {
		const before = this.state;
		if (this.authService.authState?.agent.superUser == true) {
			this.state = true;
		} else {
			const userPerms = this.authService.authState?.agent?.roles
				.flatMap(role => role.permissions ?? [])
				.filter(p => p.selected)
				.map(p => p.permission) ?? [];

			this.state = requiredPermissions.some(p => userPerms.includes(p));
		}
		if (before == this.state) {
			return;
		}
		if (before == true) {
			this.viewContainer.clear();
		} else {
			this.viewContainer.createEmbeddedView(this.templateRef);
		}
	}
}
